import { Link } from "react-router-dom";
import { HomePlateLogo } from "@/components/HomePlateLogo";

const sizeMap = {
  sm: { text: "text-base", logo: 28 },
  md: { text: "text-[20.4px]", logo: 48 },
  lg: { text: "text-xl", logo: 44 },
  xl: { text: "text-2xl", logo: 56 },
};

export function Wordmark({ size = "md", to = null, className = "" }) {
  const s = sizeMap[size] ?? sizeMap.md;
  const inner = (
    <span className={`inline-flex items-center gap-2.5 ${s.text} ${className}`}>
      <HomePlateLogo size={s.logo} />
      <span className="font-serif font-bold tracking-[0.04em] uppercase text-brand-black leading-none whitespace-nowrap">
        The Box Score Club
      </span>
    </span>
  );
  if (to) {
    return (
      <Link
        to={to}
        className="inline-flex hover:opacity-80 transition-opacity"
        data-testid="wordmark-link"
      >
        {inner}
      </Link>
    );
  }
  return inner;
}
